export const TosContent = () => (
    <>
        <h3>CensusZen Terms of Service</h3>
        <p>Last updated: February 2026</p>

        <h4>1. Acceptance of Terms</h4>
        <p>
            By accessing or using CensusZen ("the Service"), you agree to be bound by
            these Terms of Service. If you do not agree to these terms, do not use the
            Service.
        </p>

        <h4>2. Description of Service</h4>
        <p>
            CensusZen is an AI-powered tool that assists clinical liaisons in generating
            structured clinical assessments from medical documents. The Service is
            intended as a decision-support tool and does not replace professional
            clinical judgment.
        </p>

        <h4>3. User Responsibilities</h4>
        <p>
            You are responsible for ensuring that all information entered into the
            Service is handled in accordance with applicable privacy regulations,
            including HIPAA. You agree to review all AI-generated content for accuracy
            before use in any clinical or administrative context.
        </p>

        <h4>4. Data Privacy</h4>
        <p>
            We process uploaded documents solely for the purpose of generating
            assessments. Documents are stored securely and are not shared with third
            parties except as necessary for AI processing (Google Gemini). For complete
            details, see our{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
            </a>.
        </p>

        <h4>5. Limitation of Liability</h4>
        <p>
            The Service is provided "as is" without warranties of any kind. We are not
            liable for any clinical decisions made based on AI-generated content.
        </p>

        <h4>6. Modifications</h4>
        <p>
            We reserve the right to modify these terms at any time. Continued use of
            the Service after changes constitutes acceptance of the modified terms.
        </p>
    </>
);
